<template>
  <default>
    <div class="admin-layout">
      <div class="container-fluid">
        <div class="row">
          <!-- Sidebar -->
          <nav
            id="adminSidebar"
            class="col-md-3 col-lg-2 d-md-block sidebar py-4"
          >
            <div class="position-sticky">
              <h6
                class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted text-uppercase"
              >
                <span>Administration</span>
              </h6>
              <ul class="nav flex-column">
                <li
                  v-for="option in adminOptions"
                  :key="option.path"
                  class="nav-item"
                >
                  <StoreLink
                    :href="`/admin/${option.path}`"
                    class="nav-link d-flex align-items-center"
                    active-class="active"
                  >
                    <component :is="option.icon" class="me-2" size="34" />
                    {{ option.name }}
                  </StoreLink>
                </li>
              </ul>
            </div>
          </nav>
          <!-- Main Content -->
          <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4 py-4 mt-3">
            <slot />
          </main>
        </div>
      </div>
    </div>
  </default>
</template>

<script lang="ts" setup>
import { onMounted, computed } from "vue";
import Default from "~/layouts/default.vue";
import {
  PhGauge,
  PhClockClockwise,
  PhWarningCircle,
  PhKey,
  PhFileText,
  PhEnvelope,
  PhUserCheck,
  PhIdentificationCard,
  PhGear,
  PhCpu,
  PhTarget,
  PhCube,
  PhTag,
  PhMagnifyingGlass,
  PhShieldStar,
  PhToolbox,
  PhBook,
  PhCertificate,
  PhFileArrowDown,
  PhPlus,
  PhCode,
  PhDevices,
  PhCurrencyDollar,
} from "@phosphor-icons/vue";
import StoreLink from "~/components/shared/buttons/StoreLink.vue";

const adminOptions = computed(() => [
  { name: "Dashboard", path: "dashboard", icon: PhGauge },
  { name: "Journal", path: "journal", icon: PhClockClockwise },
  {
    name: "License Install Errors",
    path: "applicenseinstallerrors",
    icon: PhWarningCircle,
  },
  { name: "License Check", path: "licensecheck", icon: PhKey },
  {
    name: "Orders",
    path: "orders",
    icon: PhCurrencyDollar,
  },
  {
    name: "Invoices Templates",
    path: "invoicesandtemplates",
    icon: PhFileText,
  },
  { name: "Emails", path: "emails", icon: PhEnvelope },
  {
    name: "Approve Developers",
    path: "approvedeveloper",
    icon: PhUserCheck,
  },
  {
    name: "Approve PxC Customer Nr",
    path: "approvepxcnumber",
    icon: PhIdentificationCard,
  },
  { name: "App Settings", path: "appsettings", icon: PhGear },
  { name: "Firmware Versions", path: "firmwareversions", icon: PhCpu },
  { name: "Target Types", path: "managetargettypes", icon: PhTarget },
  { name: "App Types", path: "apptypes", icon: PhCube },
  { name: "Categories", path: "appscategories", icon: PhTag },
  { name: "Search User", path: "searchuser", icon: PhMagnifyingGlass },
  {
    name: "Device Management",
    path: "devicemanagement",
    icon: PhDevices,
  },
  {
    name: "Make Others Admin",
    path: "makeothersadmin",
    icon: PhShieldStar,
  },
  { name: "Maintenance Banner", path: "maintenance", icon: PhToolbox },
  { name: "Knowledge Base", path: "knowledgebase", icon: PhBook },
  { name: "Certify Apps", path: "certifyapp", icon: PhCertificate },
  {
    name: "Import Desktop Tool",
    path: "importdesktoptool",
    icon: PhFileArrowDown,
  },
  { name: "More Configs", path: "moreconfigs", icon: PhPlus },
  { name: "Service Api Swagger", path: "serviceapiswagger", icon: PhCode },
]);

onMounted(() => {
  console.debug("admin layout mounted");
});
</script>

<style lang="scss" scoped>
@use "@/sass/layouts/Admin.scss" as *;
</style>
